import React from 'react';
import EditableListingInfoRegion from './EditableListingInfoRegion';
import BasicSidebarClaimedCard from './BasicSidebarClaimedCard';
import BasicSidebarCategoriesCard from './BasicSidebarCategoriesCard';

function BasicRightSidebar({ category, listing, canEditListingInfo = false, onEditCategories, onClaim, tagsPanel }) {

  return (
    <aside id="RightSidebar" className="mt-6 lg:mt-0">
      <div id="RightSidebar-StickyContent" className="space-y-4 lg:sticky lg:top-24">
        <div className="hidden lg:block"><EditableListingInfoRegion canEdit={canEditListingInfo}>
          <BasicSidebarClaimedCard listing={listing} onClaim={onClaim} />
        </EditableListingInfoRegion></div>
        <div className="hidden lg:block"><EditableListingInfoRegion canEdit={canEditListingInfo}>
          <BasicSidebarCategoriesCard
            category={category}
            listing={listing}
            canEdit={canEditListingInfo}
            onEdit={onEditCategories}
          />
        </EditableListingInfoRegion></div>
        {tagsPanel}
      </div>
    </aside>
  );
}

export default BasicRightSidebar;
